export const GENERAL_FORM_FIELDS: { [key: string]: { label: string } } = {
  name: { label: 'Your Name' },
  email: { label: 'Your Email' },
  phone: { label: 'Phone Number' },
  subject: { label: 'Subject' },
  message: { label: 'Message' },
};

export const EMAIL_SIGNUP_FORM_FIELDS: { [key: string]: { label: string } } = {
  fname: { label: 'First Name' },
  lname: { label: 'Last Name' },
  email: { label: 'Email' },
};

export const PROPERTY_MANAGEMENT_FORM_FIELDS: {
  [key: string]: { label: string; placeholder: string };
} = {
  name: { label: 'Your Name', placeholder: 'Full name' },
  email: { label: 'Your Email', placeholder: 'Contact email' },
  phone: {
    label: 'Phone Number',
    placeholder: 'Contact phone number (optional)',
  },
  message: { label: 'Message', placeholder: 'Tell us about your needs...' },
};

export const REALTOR_REFERRAL_FORM_FIELDS: {
  [key: string]: { label: string; placeholder: string };
} = {
  agentName: {
    label: 'Name',
    placeholder: PROPERTY_MANAGEMENT_FORM_FIELDS.name.placeholder,
  },
  agentEmail: {
    label: 'Email',
    placeholder: PROPERTY_MANAGEMENT_FORM_FIELDS.email.placeholder,
  },
  agentPhone: {
    label: 'Phone',
    placeholder: PROPERTY_MANAGEMENT_FORM_FIELDS.phone.placeholder,
  },
  clientName: {
    label: 'Name',
    placeholder: PROPERTY_MANAGEMENT_FORM_FIELDS.name.placeholder,
  },
  clientEmail: {
    label: 'Email',
    placeholder: PROPERTY_MANAGEMENT_FORM_FIELDS.email.placeholder,
  },
  comments: {
    label: 'Comments',
    placeholder: PROPERTY_MANAGEMENT_FORM_FIELDS.message.placeholder,
  },
};

export const EMPLOYMENT_FORM_FIELDS: {
  [key: string]: { label: string };
} = {
  name: { label: 'Your Name' },
  email: { label: 'Your Email' },
  phone: { label: 'Phone Number' },
  position: { label: 'Position of Interest' },
  experience: { label: 'Years of Experience' },
  message: { label: 'How did you hear about us?' },
};
